import PropTypes from 'prop-types';
import React, { Component } from 'react';
import injectSheet from 'react-jss';

import { injectIntl } from 'react-intl';

import EcUserItem from '../EcUserItem/EcUserItem';
import styles from './EcUserTable.styles';

class EcUserTable extends Component {
  renderUserListItems() {
    const { listItems, handleShowModal, intl } = this.props;
    if (!listItems.length)
      return (
        <tr>
          <td>
            {intl.formatMessage({
              id: 'EcUserTable.noCurrentUsers',
              defaultMessage: 'No current users',
              description: 'Message when no users are found in the table',
            })}
          </td>
        </tr>
      );
    return listItems.map((item, index) => {
      return (
        <EcUserItem
          item={item}
          key={`item-${index}`}
          handleShowModal={handleShowModal}
        />
      );
    });
  }

  render() {
    const { classes, intl } = this.props;

    return (
      <table className={classes.userTable}>
        <thead>
          <tr>
            <th className={classes.headerColumn}>
              {intl.formatMessage({
                id: 'EcUserTable.usersHeader',
                defaultMessage: 'Users',
                description: 'Main header for users table',
              })}
            </th>
            <th className={classes.headerColumn} />
            <th className={classes.headerColumn} />
            <th className={classes.headerColumn} />
            <th className={classes.headerColumn} />
            <th className={classes.headerColumn} />
          </tr>
          <tr>
            <th className={classes.headerColumn}>
              {intl.formatMessage({
                id: 'EcUserTable.emailHeader',
                defaultMessage: 'Email',
                description: 'Column header for user email',
              })}
            </th>
            <th className={classes.headerColumn}>
              {intl.formatMessage({
                id: 'EcUserTable.nameHeader',
                defaultMessage: 'Name',
                description: 'Column header for user name',
              })}
            </th>
            <th className={classes.headerColumn}>
              {intl.formatMessage({
                id: 'EcUserTable.lastAccessHeader',
                defaultMessage: 'Last Access',
                description: 'Column header for last access date',
              })}
            </th>
            <th className={classes.headerColumn}>
              {intl.formatMessage({
                id: 'EcUserTable.accessLevelHeader',
                defaultMessage: 'Access Level',
                description: 'Column header for user access level',
              })}
            </th>
            <th className={classes.headerColumn}>
              {intl.formatMessage({
                id: 'EcUserTable.departmentHeader',
                defaultMessage: 'Department',
                description: 'Column header for user department',
              })}
            </th>
            <th className={classes.headerColumn}>
              {intl.formatMessage({
                id: 'EcUserTable.jobTitleHeader',
                defaultMessage: 'Job Title',
                description: 'Column header for user job title',
              })}
            </th>
            <th className={classes.headerColumn} />
          </tr>
        </thead>
        <tbody>{this.renderUserListItems()}</tbody>
      </table>
    );
  }
}

EcUserTable.propTypes = {
  classes: PropTypes.object.isRequired,
  listItems: PropTypes.array.isRequired,
  handleShowModal: PropTypes.func,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(injectSheet(styles)(EcUserTable));
